<template>
  <div>
    <MenuButton fullWidth>
      <template #menu-button-trigger>
        <ShowingAgentPickerTrigger :isLoading="isLoading" :selectedShowingAgent="selectedShowingAgent" />
      </template>

      <MenuButtonItem
        v-for="showingAgent in showingAgents"
        :key="showingAgent.id"
        :title="getFullName(showingAgent)"
        :subtitle="formatPhoneNumber(showingAgent.phone)"
        @click="selectAgent(showingAgent)"
        icon="user-03"
      >
        <template #prefix>
          <ShowingAgentPickerAvatar :showingAgent="showingAgent" />
        </template>
      </MenuButtonItem>
      <MenuButtonItem title="Add new agent" icon="plus" @click="addShowingAgentModalRef?.modalRef?.show()">
        <template #prefix>
          <ShowingAgentPickerAvatarPlaceholder icon="plus" />
        </template>
      </MenuButtonItem>
    </MenuButton>

    <AddShowingAgentModel ref="addShowingAgentModalRef" @created="selectAgent" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { MenuButton, MenuButtonItem } from '@tallo/design-system';
import { getFullName, formatPhoneNumber } from '@tallo/utility';

import { ShowingAgentDto } from '../interfaces/showing-agent.dto';
import { useShowingAgentsQuery } from '../queries/showing-agents.query';
import AddShowingAgentModel from './add-showing-agent-model.vue';
import ShowingAgentPickerAvatarPlaceholder from './showing-agent-picker-avatar-placeholder.vue';
import ShowingAgentPickerAvatar from './showing-agent-picker-avatar.vue';
import ShowingAgentPickerTrigger from './showing-agent-picker-trigger.vue';

const model = defineModel();
const showingAgentsQuery = useShowingAgentsQuery();
const isLoading = computed(() => showingAgentsQuery.isLoading.value);
const showingAgents = computed(() => showingAgentsQuery.data.value || []);
const selectedShowingAgent = computed(() => showingAgents.value.find(({ id }) => id === model.value));
const addShowingAgentModalRef = ref<InstanceType<typeof AddShowingAgentModel>>();

function selectAgent(showingAgent: ShowingAgentDto) {
  model.value = showingAgent.id;
}
</script>

<style scoped lang="scss"></style>
